import React from 'react';
import { Link } from 'react-router-dom';
import { MostImportantChangesTable } from '../tables/MostImportantChangesTable';
import { useFetchBuildingTopChanges } from 'api/anomalies/anomalyServices';
import { useConditionalRender } from 'hooks/useConditionalRender';

interface TopDetectedChangesTableProps {
  buildingId: string | undefined;
  severity: string;
}

const TopDetectedChangesTable: React.FC<TopDetectedChangesTableProps> = ({
  buildingId,
  severity,
}) => {
  const { data, isFetching } = useFetchBuildingTopChanges(buildingId);
  const { shouldRender } = useConditionalRender({
    isFetching,
    data: data?.anomaly_detections,
  });

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4 h-full">
      <div className="flex w-full justify-between items-center my-2">
        <h3 className="font-bold uppercase">Most important anomalies</h3>

        <Link
          to={`/app/operations/anomalies?asset=${buildingId ?? ''}`}
          className="text-base mr-6 text-tertiary-dark"
        >
          See all
        </Link>
      </div>
      <MostImportantChangesTable buildingId={buildingId} severity={severity} />
    </div>
  );
};

export default TopDetectedChangesTable;
